import { number, shape } from "prop-types";

import ErrorBoundary from "web/Layout/ErrorBoundary";

import Product from "./product";

const ProductCardListContainer = ({ classes, product, positionNumber }) => {
  return (
    <ErrorBoundary>
      <Product
        positionNumber={positionNumber}
        classes={classes}
        product={product}
      />
    </ErrorBoundary>
  );
};

ProductCardListContainer.propTypes = {
  classes: shape({}).isRequired,
  product: shape({}).isRequired,
  positionNumber: number,
};

ProductCardListContainer.defaultProps = {
  positionNumber: 0,
};

export default ProductCardListContainer;
